<template>
<div>
    <h2>
        <div>{{ $t("allStatisticsView.topOrganizations", [numTop]) }}</div>
        <div>{{ getCurrentSeasonYears() }}</div>
    </h2>
    <table>
        <thead>
            <tr>
                <th></th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(o, i) in allOrganizations.slice(0, numTop)"
                :key="o.organizationId"
                :class="{ hilight: o.organizationId === store.selectedOrganization.organizationId }">

                <td>{{ i + 1 }}</td>
                <td>{{ o.name }}</td>
                <td>{{ $n(o.totalSponsorshipAmount, "currency") }}</td>
            </tr>
            <tr v-if="userOrganizationPos >= numTop">
                <td>...</td>
                <td></td>
                <td></td>
            </tr>
            <tr class="hilight" v-if="userOrganizationPos >= numTop">
                <td>{{ userOrganizationPos + 1 }}</td>
                <td>{{ userOrganization.name }}</td>
                <td>{{ $n(userOrganization.totalSponsorshipAmount, "currency") }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script lang="ts">
import { store, Organization } from "store";
import axios from "axios";
import { defineComponent } from "vue";

interface SetupData {
    allOrganizations: Organization[];
    userOrganization: Organization;
    userOrganizationPos: number;
}

// TODO: rename to TopOrganizationsView
export default defineComponent({
    async setup(): SetupData {
        // Organization statistics are based on the current year
        let currentYear = new Date().getFullYear();
        let allOrganizations = (await axios.get<Organization[]>("organizations/all", {
            params: {
                eventsFromYear: currentYear,
                includeZeroAmountSponsorships: true,
            }
        })).data;

        allOrganizations.sort((a, b) => b.totalSponsorshipAmount - a.totalSponsorshipAmount);

        const userOrganization = allOrganizations.find(o => o.organizationId == store.selectedOrganization.organizationId);
        const userOrganizationPos = allOrganizations.indexOf(userOrganization);

        return {
            allOrganizations,
            userOrganization,
            userOrganizationPos,
        };
    },
    data() {
        return {
            store: store,
        };
    },
    methods: {
        getCurrentSeasonYears() {
            let year = new Date(Date.now()).getFullYear();

            return `${year} - ${year + 1}`;
        }
    },
    props: {
        numTop: {
            type: Number
        }
    }
})
</script>